import React, { Component } from "react";
import { Fragment } from "react";
// import Trucks_Schedule from "./Trucks_Schedule.js";
import Trucks_Available from "./Trucks_Available.js";
import "./BlockData.css";
import axios from "axios";
import moment from "moment-timezone";
import { API_URL1 } from "../services/url";
import { LinearProgress } from "@material-ui/core";
// Lightweight stat card used across the dashboard
// Dependency-free SVG bar chart for "Tons Moved" trend. Keeps the bundle lean
// (no chart lib) and matches the inline-styled cards used elsewhere here.
const TonnageBarChart = ({ data = [], labels = [], loads = [] }) => {
  const W = 920, H = 240, padL = 44, padR = 12, padT = 16, padB = 28;
  const plotW = W - padL - padR;
  const plotH = H - padT - padB;
  const max = Math.max(1, ...data.map((v) => Number(v) || 0));
  const n = data.length || 1;
  const slot = plotW / n;
  const barW = Math.min(46, slot * 0.62);
  const niceMax = Math.ceil(max / 100) * 100 || 100;
  const ticks = 4;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block' }} role="img" aria-label="Tons moved per month">
      {Array.from({ length: ticks + 1 }).map((_, i) => {
        const val = (niceMax / ticks) * (ticks - i);
        const y = padT + (plotH / ticks) * i;
        return (
          <g key={i}>
            <line x1={padL} y1={y} x2={W - padR} y2={y} stroke="#eef0f3" strokeWidth="1" />
            <text x={padL - 8} y={y + 4} textAnchor="end" fontSize="10" fill="#94a3b8">{Math.round(val)}</text>
          </g>
        );
      })}
      {data.map((v, i) => {
        const val = Number(v) || 0;
        const h = (val / niceMax) * plotH;
        const x = padL + slot * i + (slot - barW) / 2;
        const y = padT + plotH - h;
        return (
          <g key={i}>
            <title>{`${labels[i]?.label || ''}: ${val.toFixed(1)} tons${loads[i] != null ? ` · ${loads[i]} loads` : ''}`}</title>
            <rect x={x} y={y} width={barW} height={Math.max(0, h)} rx="4"
              fill="url(#tonGrad)" />
            {val > 0 && (
              <text x={x + barW / 2} y={y - 4} textAnchor="middle" fontSize="9" fill="#475569" fontWeight="700">
                {Math.round(val)}
              </text>
            )}
            <text x={padL + slot * i + slot / 2} y={H - 8} textAnchor="middle" fontSize="10" fill="#64748b">
              {labels[i]?.label || ''}
            </text>
          </g>
        );
      })}
      <defs>
        <linearGradient id="tonGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#991C1C" />
          <stop offset="100%" stopColor="#c2410c" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const StatCard = ({ label, value, sublabel }) => (
  <div
    style={{
      flex: '1 1 260px',
      minWidth: 260,
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderRadius: 12,
      boxShadow: '0 8px 16px rgba(2,6,23,0.06)',
      padding: '16px 18px',
      margin: 8
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
      <div style={{ 
        width: 5, 
        height: 18, 
        background: 'linear-gradient(135deg, #991C1C 0%, #7d1616 50%, #6b1212 100%)', 
        borderRadius: 3, 
        marginRight: 10 
      }}></div>
      <div style={{ fontSize: 13, color: '#64748b', fontWeight: 600 }}>{label}</div>
    </div>
    <div style={{ fontSize: 28, fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{Number(value || 0).toFixed(2)}</div>
    {sublabel ? (
      <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 600, marginTop: 6 }}>{sublabel}</div>
    ) : null}
  </div>
);

// Shimmer placeholders shown while the dashboard loads — so the user never sees
// the bare "0.00 / no trucks" state flash before real data arrives.
const SkeletonBox = ({ h = 28, w = '100%', r = 8, mt = 0 }) => (
  <div style={{
    height: h, width: w, borderRadius: r, marginTop: mt,
    background: 'linear-gradient(90deg,#eef1f5 25%,#e2e8f0 37%,#eef1f5 63%)',
    backgroundSize: '800px 100%', animation: 'rpShimmer 1.4s ease infinite',
  }} />
);
const SkeletonStatCard = () => (
  <div style={{
    flex: '1 1 260px', minWidth: 260, background: '#fff', border: '1px solid #e5e7eb',
    borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)', padding: '16px 18px', margin: 8,
  }}>
    <SkeletonBox h={12} w="55%" />
    <SkeletonBox h={26} w="40%" mt={14} />
    <SkeletonBox h={10} w="30%" mt={12} />
  </div>
);

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Udata: [],
      dispatch_today: "",
      dispatch_week: "",
      dispatch_year: "",
      tons_today: "",
      tons_week: "",
      tons_year: "",
      hauled_today: "",
      hauled_week: "",
      hauled_year: "",
      monthlyTons: [],
      monthlyLoads: [],
      monthLabels: [],
      monthlyTonsTotal: 0,
      record: false,
    };
  }

  // Safely get a numeric stat from API result array (backend returns 9 result sets in order)
  getStat(truckes, index, field) {
    const row = truckes?.[index]?.[0];
    const val = row?.[field];
    if (val === undefined || val === null) return 0;
    const n = Number(val);
    return isNaN(n) ? 0 : n;
  }

  // Compute dashboard numbers from the list of dispatched orders.  The order
  // object is expected to contain a date field (departed_quarry, to_date,
  // loaded, etc.) and processing_quantity.  This mirrors the data consumed by
  // the map/dispatch screens which the user reports are correct.
  computeStatsFromOrders(orders) {
    // Use Mountain Time (America/Denver) for all date calculations
    const nowMT = moment.tz('America/Denver');
    const startOfTodayMT = nowMT.clone().startOf('day');
    const endOfTodayMT = nowMT.clone().endOf('day');

    const weekAgoMT = startOfTodayMT.clone().subtract(7, 'days');
    // use a rolling 365‑day window for the "year" statistic so it will differ from
    // the 7‑day count unless all orders fall within one week.
    const yearAgoMT = startOfTodayMT.clone().subtract(365, 'days');

    const stats = {
      dispatch_today: 0,
      dispatch_week: 0,
      dispatch_year: 0,
      tons_today: 0,
      tons_week: 0,
      tons_year: 0,
      hauled_today: 0,
      hauled_week: 0,
      hauled_year: 0,
    };
    let sawHauled = false;

    orders.forEach(o => {
      // Parse dispatch date fields - try multiple possible field names
      const dispatchDateVal = o.departed_quarry || o.loaded || o.dispatch_date || o.to_date;
      const dispatchDateMT = dispatchDateVal ? moment.tz(dispatchDateVal, 'America/Denver') : null;
      if (dispatchDateMT && dispatchDateMT.isValid()) {
        if (dispatchDateMT.isBetween(startOfTodayMT, endOfTodayMT, null, '[]')) {
          stats.dispatch_today += 1;
        }
        if (dispatchDateMT.isBetween(weekAgoMT, endOfTodayMT, null, '[]')) {
          stats.dispatch_week += 1;
        }
        if (dispatchDateMT.isBetween(yearAgoMT, endOfTodayMT, null, '[]')) {
          stats.dispatch_year += 1;
        }
      }

      // Sum tons moved - try multiple quantity field names
      const qty = Number(o.processing_quantity || o.true_quantity || o.actual_quantity || o.quantity || o.qty || 0);
      if (dispatchDateMT && dispatchDateMT.isValid()) {
        if (dispatchDateMT.isBetween(startOfTodayMT, endOfTodayMT, null, '[]')) {
          stats.tons_today += qty;
        }
        if (dispatchDateMT.isBetween(weekAgoMT, endOfTodayMT, null, '[]')) {
          stats.tons_week += qty;
        }
        if (dispatchDateMT.isBetween(yearAgoMT, endOfTodayMT, null, '[]')) {
          stats.tons_year += qty;
        }
      }

      // Parse hauled/delivery date fields - try multiple possible field names
      const hauledDateVal = o.date_delivered || o.delivered_date || o.delivery_date || o.completed || o.date_completed;
      const hauledDateMT = hauledDateVal ? moment.tz(hauledDateVal, 'America/Denver') : null;
      if (hauledDateMT && hauledDateMT.isValid()) {
        sawHauled = true;
        if (hauledDateMT.isBetween(startOfTodayMT, endOfTodayMT, null, '[]')) {
          stats.hauled_today += 1;
        }
        if (hauledDateMT.isBetween(weekAgoMT, endOfTodayMT, null, '[]')) {
          stats.hauled_week += 1;
        }
        if (hauledDateMT.isBetween(yearAgoMT, endOfTodayMT, null, '[]')) {
          stats.hauled_year += 1;
        }
      }
    });

    return { stats, sawHauled };
  }

  async componentDidMount() {
    try {
      const truck_company_id = localStorage.getItem("adminid");
      if (!truck_company_id) {
        this.setState({ record: true });
        return;
      }

      const headers = {
        "x-access-token": localStorage.getItem("TruckertokenKey"),
        "content-type": "application/json",
      };
      const get = (path) => axios.get(`${API_URL1}${path}`, { headers });

      // Fire the 3 independent calls in PARALLEL (was sequential → ~sum of
      // latencies, 10s+). The legacy dashboardNew counts endpoint is slow
      // (~2.4s of redundant COUNT queries) and is ONLY a fallback, so it is no
      // longer in the blocking path — fetched lazily only if compute fails.
      const [scheduleResp, ordersResp, tonsResp] = await Promise.allSettled([
        get(`trucker/dashboardNew/dashboardTruckSchedule/${truck_company_id}`),
        get(`trucker/dispatch/dispatched?page=1&limit=100000`),
        get(`trucker/dashboardNew/monthlyTons/${truck_company_id}`),
      ]);

      const udata = scheduleResp.status === "fulfilled"
        ? (scheduleResp.value.data?.success?.data ?? []) : [];

      let stats = {
        dispatch_today: 0, dispatch_week: 0, dispatch_year: 0,
        tons_today: 0, tons_week: 0, tons_year: 0,
        hauled_today: 0, hauled_week: 0, hauled_year: 0,
      };
      let computedFromOrders = false;
      let sawHauled = false;
      const orders = ordersResp.status === "fulfilled" ? (ordersResp.value.data?.data || []) : [];
      if (Array.isArray(orders) && orders.length > 0) {
        const result = this.computeStatsFromOrders(orders);
        stats = result.stats;
        computedFromOrders = true;
        sawHauled = result.sawHauled;
      }

      // Tons-moved trend (parallel result)
      if (tonsResp.status === "fulfilled" && tonsResp.value.data?.success) {
        const td = tonsResp.value.data;
        this.setState({
          monthlyTons: td.monthlyData || [],
          monthlyLoads: td.monthlyLoads || [],
          monthLabels: td.monthLabels || [],
          monthlyTonsTotal: Number(td.yearTotal || 0),
        });
      }

      // Legacy counts endpoint: only hit it as a fallback when client compute failed.
      let truckes = null;
      if (!computedFromOrders) {
        try {
          const legacy = await get(`trucker/dashboardNew/${truck_company_id}`);
          truckes = legacy.data?.truckes;
        } catch (e) {
          console.warn("Dashboard: legacy stats fallback failed", e);
        }
      }

      this.setState({
        Udata: Array.isArray(udata) ? udata : [],
        // Always use computed stats if successfully computed from orders
        // Only fall back to legacy API if computation completely failed
        dispatch_today: computedFromOrders ? stats.dispatch_today : this.getStat(truckes, 0, "dispatch_today"),
        dispatch_week: computedFromOrders ? stats.dispatch_week : this.getStat(truckes, 1, "dispatch_week"),
        dispatch_year: computedFromOrders ? stats.dispatch_year : this.getStat(truckes, 2, "dispatch_year"),
        tons_today: computedFromOrders ? stats.tons_today : this.getStat(truckes, 3, "tons_today"),
        tons_week: computedFromOrders ? stats.tons_week : this.getStat(truckes, 4, "tons_week"),
        tons_year: computedFromOrders ? stats.tons_year : this.getStat(truckes, 5, "tons_year"),
        hauled_today: (computedFromOrders && sawHauled) ? stats.hauled_today : this.getStat(truckes, 6, "hauled_today"),
        hauled_week: (computedFromOrders && sawHauled) ? stats.hauled_week : this.getStat(truckes, 7, "hauled_week"),
        hauled_year: (computedFromOrders && sawHauled) ? stats.hauled_year : this.getStat(truckes, 8, "hauled_year"),
        record: true,
      });
      console.log("📊 Dashboard state updated - computedFromOrders:", computedFromOrders);
    } catch (error) {
      console.error("Dashboard fetch error:", error);
      this.setState({ record: true });
    }
  }
  renderSkeleton() {
    return (
      <Fragment>
        <style>{`@keyframes rpShimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}`}</style>
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
          <div style={{ padding: '24px 24px 8px 24px' }}>
            <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: '#0f172a', letterSpacing: 0.2 }}>Dashboard Overview</h1>
            <p style={{ margin: '6px 0 0 0', color: '#64748b', fontSize: 14 }}>Track dispatches, tons moved and loads hauled</p>
          </div>
          <div style={{ padding: '8px 16px 16px 16px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              {Array.from({ length: 9 }).map((_, i) => <SkeletonStatCard key={i} />)}
            </div>
          </div>
          <div style={{ padding: '0 16px 8px 16px' }}>
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)', padding: 16 }}>
              <SkeletonBox h={16} w="240px" />
              <SkeletonBox h={200} mt={16} />
            </div>
          </div>
          <div style={{ padding: '0 16px 24px 16px' }}>
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 8px 16px rgba(2,6,23,0.06)', padding: 16 }}>
              <SkeletonBox h={16} w="160px" />
              {Array.from({ length: 4 }).map((_, i) => <SkeletonBox key={i} h={40} mt={12} />)}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  render() {
    if (!this.state.record) return this.renderSkeleton();
    return (
      <Fragment>
        <div style={{
          backgroundColor: '#f8f9fa'
        }}>
          {/* Page header */}
          <div style={{ padding: '24px 24px 8px 24px' }}>
            <h1 style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 800,
              color: '#0f172a',
              letterSpacing: 0.2
            }}>Dashboard Overview</h1>
            <p style={{ margin: '6px 0 0 0', color: '#64748b', fontSize: 14 }}>Track dispatches, tons moved and loads hauled</p>
          </div>

          {/* Stats grid */}
          <div style={{ padding: '8px 16px 16px 16px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <StatCard label="Dispatched Today" value={this.state.dispatch_today} sublabel="Today" />
              <StatCard label="Dispatched This Week" value={this.state.dispatch_week} sublabel="Last 7 days" />
              <StatCard label="Dispatched This Year" value={this.state.dispatch_year} sublabel="Year to date" />

              <StatCard label="Tons Moved Today" value={this.state.tons_today} sublabel="Today" />
              <StatCard label="Tons Moved This Week" value={this.state.tons_week} sublabel="Last 7 days" />
              <StatCard label="Tons Moved This Year" value={this.state.tons_year} sublabel="Year to date" />

              <StatCard label="Loads Hauled Today" value={this.state.hauled_today} sublabel="Today" />
              <StatCard label="Loads Hauled This Week" value={this.state.hauled_week} sublabel="Last 7 days" />
              <StatCard label="Loads Hauled This Year" value={this.state.hauled_year} sublabel="Year to date" />
            </div>
          </div>

          {/* Tons Moved trend */}
          <div style={{ padding: '0 16px 8px 16px' }}>
            <div style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              boxShadow: '0 8px 16px rgba(2,6,23,0.06)',
              padding: 16
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ width: 4, height: 20, background: '#991C1C', borderRadius: 2, marginRight: 8 }}></div>
                <div style={{ fontWeight: 800, color: '#0f172a' }}>Tons Moved — Last 12 Months</div>
                <div style={{ marginLeft: 'auto', fontSize: 13, color: '#64748b', fontWeight: 700 }}>
                  Total: {Number(this.state.monthlyTonsTotal || 0).toLocaleString(undefined, { maximumFractionDigits: 1 })} tons
                </div>
              </div>
              {this.state.monthlyTons.some(v => Number(v) > 0) ? (
                <TonnageBarChart
                  data={this.state.monthlyTons}
                  labels={this.state.monthLabels}
                  loads={this.state.monthlyLoads}
                />
              ) : (
                <div style={{ color: '#94a3b8', fontSize: 13, padding: '24px 0', textAlign: 'center' }}>
                  No delivered tonnage in the last 12 months yet.
                </div>
              )}
            </div>
          </div>

          {/* Trucks Available */}
          <div style={{ padding: '0 16px 24px 16px' }}>
            <div style={{
              background: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              boxShadow: '0 8px 16px rgba(2,6,23,0.06)',
              padding: 16
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                <div style={{ width: 4, height: 20, background: '#991C1C', borderRadius: 2, marginRight: 8 }}></div>
                <div style={{ fontWeight: 800, color: '#0f172a' }}>Trucks Available</div>
              </div>
              <Trucks_Available Udata={this.state.Udata} loading={this.state.loading} />
            </div>
          </div>
          {/* <div className="row col-lg-12 d-flex justify-content-around mt-5">
            <Trucks_Schedule
              Udata={this.state.Udata}
              loading={this.state.loading}
            />
          </div> */}
        </div>
      </Fragment>
    );
  }
}

export default Dashboard;
